module.exports = __webpack_public_path__ + "static/img/card4.cfc739f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/card4.png
// module id = t4KI
// module chunks = 0